import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import { useSlice } from "components/hooks/useSlice";
import { NavigationLink } from "./NavigationLink";

const NavigationStyles = styled.nav`
  background: var(--venice-blue);
  color: white;
  padding: 5px 10px;
  display: flex;

  @media print {
    display: none;
  }

  @media only screen and (max-width: 767px) {
    flex: 1;
    min-width: 200px;
    max-width: 200px;
    transition: margin 0.2s ease;
    margin-left: -200px;
    ${({ $menuOpen }) => $menuOpen && "margin-left: 0;"}
  }

  a {
    color: inherit;
    text-decoration: none;
    padding: 2px 5px;
    display: inline;
    height: 25px;
    line-height: 20px;

    .fa {
      margin-right: 5px;
    }

    &:hover,
    &.active {
      background: var(--wedgewood);
      border-radius: 5px;
      text-decoration: none;
    }

    &.active {
      font-weight: bold;
      border: 1px solid var(--hoki);
    }
  }

  a + a {
    margin-left: 10px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 5px;

    a {
      display: block;
      margin-top: 5px;
    }

    a + a {
      margin: 5px 0 0;
    }
  }
`;

export function Navigation({ menuOpen, setMenuOpen }) {
  const {
    hasAcademicsTab,
    hasCampusTab,
    hasDashboardTab,
    hasFinancialsTab,
    hasToolboxTab,
  } = useSlice("myStatus");

  const showNavigation =
    hasAcademicsTab ||
    hasCampusTab ||
    hasDashboardTab ||
    hasFinancialsTab ||
    hasToolboxTab;

  if (showNavigation) {
    return (
      <NavigationStyles $menuOpen={menuOpen}>
        {hasDashboardTab && (
          <NavigationLink
            to="/dashboard"
            title="My Dashboard"
            icon="home"
            setMenuOpen={setMenuOpen}
          />
        )}

        {hasAcademicsTab && (
          <NavigationLink
            to="/academics"
            title="My Academics"
            icon="book"
            setMenuOpen={setMenuOpen}
          />
        )}

        {hasFinancialsTab && (
          <NavigationLink
            to="/finances"
            title="My Finances"
            icon="usd"
            setMenuOpen={setMenuOpen}
          />
        )}

        {hasCampusTab && (
          <NavigationLink
            to="/campus"
            title="My Campus"
            icon="th-large"
            setMenuOpen={setMenuOpen}
          />
        )}

        {hasToolboxTab && (
          <NavigationLink
            to="/toolbox"
            title="My Toolbox"
            icon="th-wrench"
            setMenuOpen={setMenuOpen}
          />
        )}
      </NavigationStyles>
    );
  }

  return null;
}

Navigation.displayName = "Navigation";
Navigation.propTypes = {
  menuOpen: PropTypes.bool,
  setMenuOpen: PropTypes.func,
};

export const SlideoutContainer = styled.div`
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: row;
  }
`;
